import React from "react"

export const Menu = ({ height = 32, width = 32, fill = "#272A34", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 16H28" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4 8H28" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4 24H28" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)
